<template>
  <div>
    <navbar></navbar>

    <b-card title="Add Country">
      <b-row>
        <b-col cols="12" md="3">
          <b-input v-model="name" placeholder="name"></b-input>
        </b-col>
        <b-col cols="12" md="3">
          <b-input v-model="code" placeholder="Country code ex: (DE , EN ,...)"></b-input>
        </b-col>
        <b-col cols="12" md="3">
          <b-input type="number" v-model="tax" placeholder="Country tax"></b-input>
        </b-col>
        <b-col cols="12" md="3">
          <b-form-checkbox v-model="is_mix">is Kombinierter Versand ?</b-form-checkbox>
        </b-col>
        <b-col cols="12" md="4">
          <b-button @click="storeCountry" variant="success">{{ $t('saveTitle') }}</b-button>
        </b-col>
      </b-row>
    </b-card>


    <b-card v-if="items.length >0">
      <div class="table-responsive">
        <b-table-simple>
          <b-thead>
            <b-tr>
              <b-th>name <strong>(is Kombinierter Versand ?)</strong></b-th>
              <th></th>
            </b-tr>
          </b-thead>

          <b-tbody>
            <draggable v-model="items" group="items"
                       @update="updateOrder"
                       @start="drag=true"
                       handle=".handle"
                       @end="drag=false">
              <b-tr v-for="(item,index) in items" :key="index">
                <b-td>
                  <span class="mr-4">{{ item.city_name }} ({{ item.city_code }})</span>
                  <template v-if="item.is_transport_mix === 'yes'">
                    <strong>(Kombinierter Versand)</strong>
                  </template>
                  <template v-else>
                    <strong>(no)</strong>
                  </template>
                  <br>
                  <strong>Tax: {{item.tax_amount}}%</strong>
                </b-td>
                <b-td>
                  <b-button variant="info" @click="editItem(item)">edit</b-button>
                  <b-button variant="danger" @click="deleteCountry(item.city_id)">delete</b-button>
                  <span class="ml-3 handle">
                                <span class="material-icons">drag_handle</span>
                            </span>
                </b-td>
              </b-tr>
            </draggable>

          </b-tbody>

        </b-table-simple>
      </div>
    </b-card>

  </div>
</template>

<script>
import Http from '../../Services/HttpService/HttpService'
import Notificaion from '../../Services/Notification/Nottification'
import Navbar from "../Partials/Navbar";
import draggable from 'vuedraggable'


export default {
  name: "Index",
  components: {Navbar, draggable},
  data() {
    return {
      items: [],
      editId: 0,
      name: null,
      code: null,
      tax: null,
      is_mix: false,
      cid: 0,
    }
  },
  methods: {
    updateOrder() {
      this.$Progress.start();
      Http.post(Http.apiurl() + 'country/order/items/process', {
        items: this.items
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.getCountries();
              Notificaion.success(response.data.message)
            } else {
              Notificaion.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    editItem(myItem) {
      window.scrollTo(0,0);
      this.editId = myItem.city_id;
      this.name = myItem.city_name;
      this.code = myItem.city_code;
      this.tax = myItem.tax_amount;
      this.is_mix = (myItem.is_transport_mix === 'yes' ? true : false);
    },
    getCountries() {
      this.$Progress.start();
      Http.get(Http.apiurl() + 'country/index')
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.items = response.data.data;
            } else {
              Notificaion.error(response.data.message)
            }
          })
          .catch(error => {
            this.$Progress.finish();
          })
    },
    storeCountry() {

      if (this.name === null) {
        Notificaion.error("name required");
        return;
      }

      this.$Progress.start();
      let url;
      if (this.editId > 0) {
        url = Http.apiurl() + 'country/update/' + this.editId
      } else {
        url = Http.apiurl() + 'country/store';
      }

      Http.post(url, {
        name: this.name,
        code: this.code,
        is_mix: this.is_mix,
        tax: this.tax,
      })
          .then(response => {
            this.$Progress.finish();
            if (response.data.status_code === Http.ok()) {
              this.name = null;
              this.code = null;
              this.tax = null;
              this.is_mix = null;
              this.editId = 0;
              this.getCountries();
              Notificaion.success(response.data.message)

            } else {
              Notificaion.error(response.data.message)

            }
          })
          .catch(error => {
            this.$Progress.finish();
          });

    },
    deleteCountry(id) {
      if (confirm(this.$t('alertText'))) {
        this.$Progress.start();
        Http.get(Http.apiurl() + 'country/delete/' + id)
            .then(response => {
              this.$Progress.finish();
              if (response.data.status_code === Http.ok()) {
                this.getCountries();
                Notificaion.success(response.data.message)

              } else {
                Notificaion.error(response.data.message)

              }
            })
            .catch(error => {
              this.$Progress.finish();
            })
      }

    },
  },
  created() {
    this.getCountries();
  }
}
</script>

<style scoped>

</style>